import React, { useCallback } from "react";
import { ModalDeleteStyled } from "./ModalDeleteStyled";
import { SectionTitle } from "../SectionTitle";
import { Divider } from "../Divider";
import { CTAButtonOutlined } from "../CTAButtonOutlined";
import { NoteText } from "../NoteText";
var ModalDelete = function (_a) {
    var modalId = _a.modalId, title = _a.title, note = _a.note, deleteText = _a.deleteText, _b = _a.actionBtnClass, actionBtnClass = _b === void 0 ? "red" : _b, closeModal = _a.closeModal, onDelete = _a.onDelete;
    var handleClose = useCallback(function (ev) {
        ev.preventDefault();
        closeModal(modalId);
    }, [closeModal, modalId]);
    var handleDelete = useCallback(function (ev) {
        ev.preventDefault();
        onDelete();
        closeModal(modalId);
    }, [closeModal, modalId, onDelete]);
    return (React.createElement(ModalDeleteStyled, null,
        React.createElement(SectionTitle, null, title),
        !!note && React.createElement(NoteText, { className: "note" }, note),
        React.createElement(Divider, null),
        React.createElement("div", { className: "buttons-container" },
            React.createElement(CTAButtonOutlined, { onClick: handleClose }, "Cancel"),
            React.createElement(CTAButtonOutlined, { className: actionBtnClass, onClick: handleDelete }, !!deleteText ? deleteText : "Delete"))));
};
export default ModalDelete;
//# sourceMappingURL=ModalDelete.js.map